module.exports = __webpack_public_path__ + "static/media/3-audio.610a492.wav";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/layer4/3-audio.wav
// module id = nJHe
// module chunks = 0